
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrainingSection from './components/TrainingSection';
import BlogSection from './components/BlogSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <TrainingSection />
        <BlogSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
